import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'app-formly-custom-button',
  template: `
  <div *ngIf="to['text'] != 'Not Applicable'">
    <button
      mat-raised-button
      type="button"
      class="blue_button"
      [class]="to.className"
      [color]="to.color"
      [disabled]="to.disabled || false"
      (click)="to.onClick ? to.onClick(field, $event) : null">
      {{ to['text'] }}
    </button>
  </div>
  <div *ngIf="to['text'] === 'Not Applicable'">
<button
      mat-stroked-button
      type="button"
      class="secondary_btn"
      color="secondary"
      [class]="to.className"
      [color]="to.color"
      [disabled]="to.disabled || false"
      (click)="to.onClick ? to.onClick(field, $event) : null">
      {{ to['text'] }}
    </button>
  </div>

  `,
  styles: [
    `
      .blue_button {
        margin-top: 15px;
        margin-bottom: 15px;
      }
      .secondary_btn {
        margin-top: 15px;
        margin-bottom: 15px;
      }
      ::ng-deep .mat-flat-button.mat-primary, .mat-raised-button.mat-primary, .mat-fab.mat-primary, .mat-mini-fab.mat-primary {
        background-color: var(--stdc-primary-color) !important;
        color: #fff !important;
      }
    `
  ],
  standalone: false
})
export class FormlyCustomButton extends FieldType {
  onClick(event: Event) {
    if (this.to.onClick) {
      this.to.onClick(event);
    }
  }
}
